module.exports = __webpack_public_path__ + "static/media/iconRecover-final.fd3ccd9a.svg";